export const LessonMeetingAddresses = {
    "Walpole": "8 East Street, East Walpole, MA 02032",
    "West Roxbury": "1752 Centre Street, West Roxbury, MA 02132"
};

export const Locations =["West Roxbury", "Walpole", "RMV Site TBD", "Brockton RMV Site", "Franklin RMV Site", "South Yarmouth RMV Site", "Braintree RMV Site", "Braintree - Granite St"];
